<template>
  <section class="c-section c-section--promotions">
    <div class="o-container o-container--large">
      <header>
        <h2>Discover your ikigai in Japan with</h2>
        <a href="https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en" class="c-promotions-logo" @click="$ga.event('SecretScrolls', 'Click', 'AirAsia Footer Logo');" target="_blank"><img :src="`${baseUrl}img/airasia.svg`" alt="AirAsia"></a>
      </header>

      <ul class="c-promotions">
        <li class="c-promotions__item" v-for="promo in promotions">
          <div class="c-promotions__route">
            {{ promo.from }} <icon name="plane" role="presentation" label="Plane"></icon> {{ promo.to }}
          </div>
          <div class="c-promotions__price">
            from <span>${{ promo.price }}<sup>*</sup></span>
          </div>
          <a href="https://www.airasia.com/au/en/promotion.page?rr=rr1530605&utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en" class="c-button c-button--secondary c-button--thin" target="_blank" @click="$ga.event('SecretScrolls', 'Click', `Book Now ${promo.from} ${promo.to}`);">Book Now</a>
        </li>
      </ul>

      <p class="c-promotions__conditions">*Conditions apply. See airasia.com for details. Processing fees may apply.</p>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/Icon';

export default {
  name: 'promotions',
  components: {
    Icon,
  },
  data() {
    return {
      promotions: [
        {
          from: 'Perth',
          to: 'Osaka',
          price: '349',
        },
        {
          from: 'Sydney',
          to: 'Osaka',
          price: '349',
        },
        {
          from: 'Perth',
          to: 'Tokyo',
          price: '349',
        },
        {
          from: 'Melbourne',
          to: 'Osaka',
          price: '349',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Promotions.vue?776b0926